import { getConfig } from '../../config';

export type StorageKey =
  | 'tokens'
  | 'theme'
  | 'locale'
  | 'operatorId'
  | 'userInfo'
  | 'authRedirect'
  | 'proPerso'
  | 'lastNotificationPermissionAnswered'
  | 'lastAuthMethod'
  | 'lastMarketingOptinAsked'
  | 'remoteConfig'
  | 'lastLocationPermissionAnswered';

export const getKey = (key: StorageKey, isGlobal = false) => {
  const prefix = isGlobal ? 'global' : getConfig().storagePrefix;
  return `${prefix ? `${prefix}-` : ''}${key}`;
};

export const storage = {
  setItem: (key: StorageKey, item: string, isGlobal = false) => {
    try {
      return getConfig().storage.setItem(getKey(key, isGlobal), item);
    } catch (e) {
      console.error(e);
    }
  },
  getItem: <T extends string>(key: StorageKey, isGlobal = false) => {
    try {
      return getConfig().storage.getItem(getKey(key, isGlobal)) as T | null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  setJSONItem: (
    key: StorageKey,
    item: Record<string, any> | null, // eslint-disable-line @typescript-eslint/no-explicit-any
    isGlobal = false,
  ) => {
    try {
      const itemString = item ? JSON.stringify(item) : '';
      return getConfig().storage.setItem(getKey(key, isGlobal), itemString);
    } catch (e) {
      console.error(e);
    }
  },
  getJSONItem: <T>(key: StorageKey, isGlobal = false): T | null => {
    try {
      const item = getConfig().storage.getItem(getKey(key, isGlobal));
      return item ? JSON.parse(item) : null;
    } catch (e) {
      console.error(e);
      return null;
    }
  },
  removeItem: (key: StorageKey, isGlobal = false) => {
    try {
      getConfig().storage.removeItem(getKey(key, isGlobal));
    } catch (e) {
      console.error(e);
    }
  },
};
